import { requestWithToken } from './index';
import { appConfig } from '../config/config';
import { GetFilterString } from '../helpers/general/generalHelpers';

export const getListSubjects = ({ pageNumber = 1, filters = '', pageSize = appConfig.RecordsPerPage }) => {
  let filterString = GetFilterString(filters);
  return requestWithToken({
        url: `subject?pageNumber=${pageNumber}&pageSize=${pageSize}${filterString}`,
        method: 'GET'
    })
}